// React
import * as React from 'react';
import { Switch, withRouter } from 'react-router-dom';
import { RouteWithSubRoutes } from 'src/App';
import Menubar from 'src/pages/common/Menubar'
import Footer from 'src/pages/common/Footer/Footer'
import { useState } from 'react';
import withSession from 'src/utils/withSession';
// import VerticalMenuBar from '../VerticalMenuBar';

// const access = [
//   {type : "projects",value : true},
//   {type : "presets",value : true},
//   {type : "trains",value : true},
//   {type : "datasets",value : true},
//   {type : "pre-trained",value : true},
//   {type : "analytics",value : true},
// ]

const SidebarMenu: React.FC<any> = (props: any): JSX.Element => {
  const [userData] = useState('')

  return (
    <>
      <div className='topbar-main-container'>
        <div className='topbar-vertical-bar'>
          <Menubar {...props} data={userData} />
        </div>
        <div className='topbar-menu-container' >
          <Switch>
            {props.routes.map((route: any, index: any) => (
              <RouteWithSubRoutes key={index} {...route} />
            ))}
          </Switch>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default withSession(withRouter(SidebarMenu));



// WEBPACK FOOTER //
// ./src/pages/common/Topbar/index.tsx